module.exports = __webpack_public_path__ + "static/media/avatar_hamster.f052cd34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_hamster.png
// module id = 384
// module chunks = 0